"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function AppelActionPrincipal() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section ref={ref} className="w-full bg-secondary py-16 px-4 sm:px-6 lg:px-8">
      <div className={`max-w-4xl mx-auto text-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
        <p className="text-lg sm:text-xl text-foreground mb-8 font-medium">
          Prêt à capturer vos moments précieux ?
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Link to="/ServicesPage">
            <Button size="lg" className="w-full sm:w-auto transition-transform duration-[var(--duration-fast)] hover:scale-[1.03] hover:brightness-95">
              Découvrir nos services
            </Button>
          </Link>
          <Link to="/ContactPage">
            <Button size="lg" variant="outline" className="w-full sm:w-auto transition-transform duration-[var(--duration-fast)] hover:scale-[1.03] hover:brightness-95">
              Nous contacter
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}